import * as React from 'react';
import { StatusIcon } from '../../icons/StatusIcons';
import { PropsAndElementAttrs } from '../../utils/ReactHelpers';
import { StickerProps, StickerType, StickerWidget } from './StickerWidget';

export type StatusStickerType = 'error' | 'warning' | 'info' | 'success';
export type StatusStickerProps = Omit<StickerProps, 'icon' | 'stickerType'> & {
  /** The type of Sticker to display. This affects the styling and icon of the Sticker. */
  stickerType: StatusStickerType;
};

const StickerIconSize = 14;

const StatusStickerColorMap: Record<StatusStickerType, StickerType> = {
  error: 'red',
  warning: 'yellow',
  info: 'blue',
  success: 'green',
};

/** Status Stickers have built-in icons and styling, reserved for their respective uses. */
export const StatusStickerWidget: React.FC<PropsAndElementAttrs<StatusStickerProps>> = (props) => {
  return <StickerWidget
    {...props}
    icon={<StatusIcon type={props.stickerType} size={StickerIconSize} />}
    stickerType={StatusStickerColorMap[props.stickerType]}
  />;
};
StatusStickerWidget.displayName = 'StatusStickerWidget';
